import React from 'react'
import { MenuItem, TextInput } from '@common/material'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form/types'
import { Controller, useFormContext } from 'react-hook-form'

export const RegisterItemDiagramPropertyFormItem: React.FC<
  RegisterItemPropertyFormItemProps
> = ({ property, sx, register }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={`${property.id}.annotationSetId`}
      control={control}
      rules={{
        validate: (value) => !!value || !property.required,
      }}
      render={({ field, fieldState: { error } }) => (
        <TextInput
          select
          key={property.id}
          disabled
          required={property.required}
          sx={{
            mb: 2,
            flexGrow: 1,
            ...sx,
          }}
          label={property.name}
          error={!!error}
          value={field.value || ''}
          onChange={(e) =>
            field.onChange({
              ...property,
              registerPropertyId: property.id,
              annotationSetId: e.target.value,
            })
          }
        >
          {register.diagrams.map((diagram) => (
            <MenuItem
              key={diagram.annotationSetId}
              value={diagram.annotationSetId}
            >
              {diagram.siteBoxDocumentName}
            </MenuItem>
          ))}
        </TextInput>
      )}
    />
  )
}
